import {
  Dispatch,
  ReactNode,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { TourStepWrapper } from './TourStepWrapper';

export interface TourItem {
  title: string;
  description?: ReactNode;
  componentId: string;
  action?: () => void;
  interactive?: boolean;
  onTop?: boolean;
  onRight?: boolean;
  animateTransition?: boolean;
}

export const getTourId = (tourId: string) => `[guided-tour-id="${tourId}"]`;

export function GuidedTour({
  stepIndex,
  stepCompleted,
  ...props
}: {
  path: TourItem[];
  stepIndex: number;
  stepCompleted: boolean;
  setStepCompleted: Dispatch<SetStateAction<boolean>>;
}) {
  const [component, setComponent] = useState<HTMLElement | null>(null);
  const [rect, setRect] = useState<DOMRect | null>(null);

  const getTourComponent = useCallback(() => {
    setRect(null);
    setComponent(null);
    const document = window?.document;
    if (document) {
      // get element for
      const element = document.querySelector(
        getTourId(props.path[stepIndex].componentId),
      ) as HTMLElement | null;

      if (element) {
        setComponent(element);
        setRect(element.getBoundingClientRect());
        props.setStepCompleted(false);
      }
    }
  }, [stepIndex]);

  useEffect(() => {
    window.addEventListener('resize', getTourComponent);
    window.addEventListener('scroll', getTourComponent);
    return () => {
      window.removeEventListener('resize', getTourComponent);
      window.removeEventListener('scroll', getTourComponent);
    };
  }, [getTourComponent]);

  useEffect(() => {
    getTourComponent();
  }, [stepIndex]);

  return (
    <div
      id="guided-tour"
      className="h-full w-full z-[100] fixed inset-0 pointer-events-none"
    >
      <TourStepWrapper
        stepIndex={stepIndex}
        stepCompleted={stepCompleted}
        tourStep={props.path[stepIndex]}
        component={component}
        rect={rect}
      />
    </div>
  );
}
